import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Select,
  Input,
  Form,
  Space,
  Alert,
  message,
} from "antd";
import {
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../slice";
import { selectOrderCorrectionReasons } from "../../selectors";

const { Option } = Select;
const { TextArea } = Input;

function OrderCorrection({ open, onClose, orderId, order_id }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [reasonsLoading, setReasonsLoading] = useState(false);
  const [requestSubmitting, setRequestSubmitting] = useState(false);

  const orderCorrectionReasons = useSelector(selectOrderCorrectionReasons);

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        setRequestSubmitting(true);
        dispatch(
          actions.requestOrderCorrection({
            data: {
              _id: order_id,
              reasons: values.reasons,
              remark: values.remark,
            },
            onSuccess: () => {
              message.success(
                "Order correction request submitted successfully"
              );
              setRequestSubmitting(false);
              form.resetFields();
              onClose();
            },
            onFailure: () => {
              message.error("Failed to submit order correction request");
              setRequestSubmitting(false);
            },
          })
        );
      })
      .catch((errorInfo) => {
        console.error("Validation failed:", errorInfo);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  useEffect(() => {
    setReasonsLoading(true);
    dispatch(
      actions.fetchOrderCorrectionReasons({
        onSuccess: () => setReasonsLoading(false),
        onFailure: () => setReasonsLoading(false),
      })
    );
  }, []);

  return (
    <Modal
      title={
        <Space>
          <ExclamationCircleOutlined style={{ color: "#faad14" }} />
          <span>Request Order Correction</span>
        </Space>
      }
      visible={open}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={requestSubmitting}
          onClick={handleSubmit}
        >
          Submit Request
        </Button>,
      ]}
      width={750}
      destroyOnClose
    >
      <Alert
        message="Important Note"
        description="If corrections are needed for Client, Project, Commodity, State, or District, please order regret instead of requesting corrections for these items."
        type="warning"
        icon={<InfoCircleOutlined />}
        showIcon
        style={{ marginBottom: 20 }}
      />
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          reasons: [],
          remarks: "",
        }}
      >
        <Form.Item
          name="reasons"
          label="Correction Reasons"
          rules={[
            { required: true, message: "Please select at least one reason" },
          ]}
        >
          <Select
            mode="multiple"
            placeholder="Select reasons for correction"
            style={{ width: "100%" }}
            loading={reasonsLoading}
          >
            {orderCorrectionReasons?.map((option) => (
              <Option key={option._id} value={option.label}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="remark"
          label="Remark"
          rules={[
            {
              required: true,
              message: "Please provide remarks for the correction",
            },
            {
              whitespace: true,
              message: "Remark cannot be empty or contain only spaces",
            },
          ]}
        >
          <TextArea
            rows={4}
            placeholder="Please provide detailed remarks about the corrections needed..."
            showCount
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default OrderCorrection;
